<elvia-accordion isFullWidth spacingAboveContent="16px">
  <div slot="closeLabel">
    <ng-container *ngTemplateOutlet="accordionLabelError" />
  </div>
  <div slot="openLabel">
    <ng-container *ngTemplateOutlet="accordionLabelError" />
  </div>
  <div slot="content" class="e-flex e-flex-direction-column e-align-items-start e-gap-8">
    <p>Vi klarte ikke å laste inn strømbrudd. Last inn siden på nytt, eller prøv igjen senere.</p>
    <app-unreported-outage-help />
  </div>
</elvia-accordion>

<ng-template #accordionLabelError>
  <div class="e-flex e-align-items-center e-gap-8">
    <e-icon name="removeCircle" size="xs" class="e-icon--color-info" />
    <p>Oops, noe gikk galt 😩</p>
  </div>
</ng-template>
